import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  removeElementToCart,
  showElementToCart,
} from "../../actions/home/cart_action";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import useRazorpay from "react-razorpay";
function CartData() {
  const state = useSelector((state) => state.cartReducer);
  const dispatch = useDispatch("");

  const deviceKey = localStorage.getItem("uu");
  useEffect(() => {
    dispatch(showElementToCart({ device_key: deviceKey }));
  }, []);

  const removeCartData = (id) => {
    dispatch(removeElementToCart({ id: id }));
  };

  if (state.is_done && state) {
    dispatch(showElementToCart({ device_key: deviceKey }));
  }

  const navigate = useNavigate();

  let certificateAmount = 0;
  let courseAmount = 0;
  let totalAmount = 0;
  if (state.courses && !state.loading) {
    courseAmount = state.courses.reduce((a, cer) => (a = a + cer.price), 0);
  }

  if (state.certifications && !state.loading) {
    state.certifications.map((li, i) => {
      certificateAmount = parseInt(certificateAmount) + parseInt(li.price);
    });
  }
  totalAmount = parseFloat(courseAmount) + parseFloat(certificateAmount);

  const makePayment = () => {
    if (!localStorage.getItem("token")) {
      localStorage.setItem("makePay", true);
      navigate("/login");
    } else {
      payment();
    }
  };

  const Razorpay = useRazorpay();
  const payment = useCallback(() => {
    localStorage.removeItem("makePay");
    //const amount = totalAmount * 100;

    const options = {
      key: "rzp_live_LBhcmmFsc8Hnor",
      amount: parseInt(totalAmount) * 100,
      currency: "INR",
      name: "Educloudlabs",
      description: "Buy Courses & Certification",
      image: "https://example.com/your_logo",
      handler: (res) => {
        console.log(res);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  }, [Razorpay]);

  return (
    <div className="row cource-section">
      <div className="col-12">
        <div className="cart-box">
          {state.courses.length === 0 &&
            state.certifications.length === 0 &&
            !state.loading && <h1 className="text-center">Data Not Found</h1>}

          <div className="row">
            <div className="col-4">
              <h2 className="text-white">Course/Certification Name</h2>
            </div>
            <div className="col-3 align-r">
              <h2 className="text-white">Type</h2>
            </div>
            <div className="col-3 align-r">
              <h2 className="text-white">Price</h2>
            </div>

            <div className="col-2 align-r">
              <h2 className="text-white">Action</h2>
            </div>
          </div>

          {state.courses.map((li, i) => (
            <div className="row" key={i}>
              <div className="col-4">
                <span className="text-white">{i + 1 + ")" + li.name}</span>
              </div>
              <div className="col-3 align-r">
                <span className="text-white">Course</span>
              </div>
              <div className="col-3 align-r">
                <span className="text-white">{li.price}</span>
              </div>
              <div className="col-2 align-r">
                <button
                 title={"Remove"}
                className="btn-common"
                  onClick={() => removeCartData(li.id)}
                >
                <i class="fa fa-remove"></i>
                </button>
              </div>
              <br />
            </div>
          ))}

          {state.certifications.map((li, i) => (
            <div className="row" key={i}>
              <div className="col-4">
                <span className="text-white">
                  {parseInt(state.courses.length) + parseInt(1) + ")" + li.name}
                </span>
              </div>
              <div className="col-3 align-r">
                <span className="text-white">Certification</span>
              </div>
              <div className="col-3 align-r">
                <span className="text-white">{li.price}</span>
              </div>
              <div className="col-2 align-r">
                <button
                   title="Remove"
                  className="btn-common"
                  onClick={() => removeCartData(li.id)}
                >
                <i class="fa fa-remove"></i>
                </button>
              </div>
              <br />
            </div>
          ))}

          <br />

          <div>
            <div className="row">
              <div className="col-12 align-r">
                <span className="text-white total-amt-txt">Total Amount= {totalAmount}</span>
              </div>
            </div>
            <div className="row">
              <div className="col-12 align-r">
                <button className="btn-common" onClick={() => makePayment()}>
                  Proceed to Checkout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartData;
